import React, { useState } from 'react';
import classes from "./input.module.scss";
import Picker from "emoji-picker-react";

const MessageInput = (props) => {
  const theme = props.theme;
  const [message, setMessage] = useState("");
  const sendMessage = props.sendMessage;
  const [showPicker, setShowPicker] = useState(false);

  const pickerClick = (e) => {
    e.preventDefault();
    setShowPicker(!showPicker);
  }

  const onEmojiClick = (e, emojiObject) => {
    let newMessage = message + emojiObject.emoji;
    setMessage(newMessage);
  }

  const onEnterPress = (e) => {
    // Send message using command + enter for Mac or ctrl + enter for Windows/Linux
    if(e.keyCode === 13 && e.metaKey || e.keyCode === 13 && e.ctrlKey) {
      e.preventDefault();
      sendMessage(e, message, setMessage);
    }
  }

  return (
    <form className={`${classes.MessageInputForm}`}>

      {showPicker && (<Picker pickerStyle={{ float: "right" }} native={true} onEmojiClick={onEmojiClick}/>)}

	  <div className={`${classes.InputCol}`}>
        <textarea
          value={message}
          placeholder="...Type Something"
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={onEnterPress}
        />
      </div>
      <div className={`${classes.SendCol}`}>
        <div className={`d-block`}>
          <button
            className={`${classes.Button}`}
            onClick={props.showModal}
            type="button"
            style={{ width: `65px`, height: `35px`, marginBottom: `10px`, backgroundColor: `lightgray`, color: `black` }}>
              <span className={`material-icons`}>attachment</span>
          </button>
        </div>
        <button
          disabled={message.length < 1}
          className={`${classes.Button}`}
          type="submit"
          onClick={(e) => sendMessage(e, message, setMessage)}
          style={{ width: `65px`, height: `55px`, backgroundColor: `${theme.primary_color}` }}>
            <span className={`material-icons`} style={{ paddingTop: `7px` }}>send</span>
        </button>
      </div>
    </form>
  );
}

export default MessageInput;
